module.exports = __webpack_public_path__ + "img/savant.16bfbc30.png";